export const LOGIN_WITH_GOOGLE = 'LOGIN_WITH_GOOGLE'
export const FETCH_AUTH_USER_DATA = 'FETCH_AUTH_USER_DATA'
export const LOGOUT = 'LOGOUT'
